module.exports = __webpack_public_path__ + "static/img/gcgsTop@2x.535ef9b0.png";